/** @format */
import axios from "axios";
import { getEnv } from "../../../../../../lib/env";
import * as XLSX from "xlsx";
import React, { useState } from "react";
import { motion } from "framer-motion";
import { UploadCloud, CheckCircle } from "lucide-react";

import { header } from "../../../../../../components/api/Header";

const FileUpload = ({ date }) => {
  const [data, setData] = useState();
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const [uploaded, setUploaded] = useState(false);
  const [uploading, setUploading] = useState(false);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/files/veneratsiya.xls";
    link.download = "Hisobot.xls";
    link.click();
  };

  const handleFileUpload = (e) => {
    const file = e.target.files?.[0];
    setFile(e.target.files[0]);
    setUploaded(false);
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target?.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const sheetRange = XLSX.utils.decode_range(worksheet["!ref"] || "A1");

      const startCol = XLSX.utils.decode_col("B");
      const startRow = 9;
      const endCol = XLSX.utils.decode_col("BH");
      const endRow = sheetRange.e.r;

      const rows = [];

      for (let R = startRow; R <= endRow; ++R) {
        const row = [];
        for (let C = startCol; C <= endCol; ++C) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
          const cell = worksheet[cellAddress];
          const value = cell ? cell.v : "";
          row.push(String(value ?? ""));
        }
        rows.push(row);
      }

      setData(rows);
    };

    reader.readAsBinaryString(file);
  };

  const reset = () => {
    setFile(null);
    setUploaded(false);
    setProgress(0);
  };

  const handleUpload = async () => {
    if (!data || data.length === 0) return alert("Avval ma'lumot kiriting!");

    setUploading(true);
    setUploaded(false);
    setProgress(0);

    try {
      const response = await axios.post(
        `${getEnv('REACT_APP_BASE_URL')}/v1/republik/sugorish/vegcrud`,
        {
          sana: date,
          data: data,
        },
        {
          ...header(),
          onUploadProgress: (progressEvent) => {
            const total = progressEvent.total || 100;
            let percent = 0;

            if (!progressEvent.total) {
              const interval = setInterval(() => {
                percent++;
                setProgress(percent);
                if (percent >= 100) clearInterval(interval);
              }, 50);
            } else {
              percent = Math.round((progressEvent.loaded * 100) / total);
              setProgress(percent);
            }
          },
        }
      );

      console.log("✅ Server javobi:", response.data);

      setProgress(100);
      setTimeout(() => {
        setUploading(false);
        setUploaded(true);
      }, 400);
    } catch (error) {
      console.error("❌ Xatolik:", error);
      setUploading(false);
      alert("Yuklashda xatolik yuz berdi!");
    }
  };

  return (
    <div
      className='p-4 vh-100  d-flex flex-column gap-4 align-items-center'
      style={{
        background: "linear-gradient(135deg, #f8f9fa, #e9fce7)",
      }}>
      <button
        onClick={handleDownload}
        className='w-100 btn btn-success d-flex align-items-center justify-content-center gap-2 mx-auto px-4 py-2 fw-bold shadow'>
        <i className='bi bi-file-earmark-excel-fill fs-5'></i>
        Namuna faylni yuklab olish
      </button>

      <div className='d-flex align-items-center justify-content-center vh-90'>
        {date ? (
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className='card shadow-lg border-0 p-4'
            style={{ borderRadius: "20px", width: "420px" }}>
            <h4 className='fw-bold text-center text-success mb-4'>
              Fayl yuklash
            </h4>

            <motion.label
              htmlFor='file'
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className={`border border-2 rounded-4 p-5 text-center d-flex flex-column justify-content-center align-items-center mb-3 ${
                file ? "border-success bg-light" : "border-secondary bg-white"
              }`}
              style={{
                borderStyle: "dashed",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}>
              <UploadCloud size={50} className='text-success mb-2' />
              <p className='mb-0 text-muted'>
                {file
                  ? "Boshqa fayl tanlash"
                  : "Faylni bu yerga tashlang yoki tanlang"}
              </p>
              <input
                type='file'
                id='file'
                className='d-none'
                onChange={handleFileUpload}
              />
            </motion.label>

            {file && (
              <div className='bg-light p-3 rounded-3 text-start mb-3'>
                <p className='mb-1 fw-semibold text-dark'>{file.name}</p>
                <small className='text-muted'>
                  {(file.size / 1024).toFixed(2)} KB
                </small>
              </div>
            )}

            {uploading && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className='mt-3'>
                <div className='progress' style={{ height: "8px" }}>
                  <motion.div
                    className='progress-bar progress-bar-striped progress-bar-animated bg-success'
                    initial={{ width: "0%" }}
                    animate={{ width: `${progress}%` }}
                    transition={{ duration: 0.2 }}
                    style={{ borderRadius: "10px" }}
                  />
                </div>

                <p className='text-muted mt-2 mb-0 text-center'>
                  {progress}% yuklanmoqda...
                </p>
              </motion.div>
            )}

            {uploaded && (
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ type: "spring", stiffness: 200, damping: 12 }}
                className='text-center mt-4'>
                <CheckCircle size={48} className='text-success mb-2' />
                <p className='text-success fw-semibold'>
                  Fayl muvaffaqiyatli yuklandi!
                </p>
              </motion.div>
            )}

            <div className='d-flex justify-content-center gap-2 mt-4'>
              {!uploaded && (
                <motion.button
                  whileTap={{ scale: 0.95 }}
                  onClick={handleUpload}
                  disabled={!file || uploading}
                  className={`btn btn-success px-4 ${
                    uploading ? "opacity-75" : ""
                  }`}>
                  {uploading ? "Yuklanmoqda..." : "Yuklash"}
                </motion.button>
              )}
              {(uploaded || file) && (
                <motion.button
                  whileTap={{ scale: 0.95 }}
                  onClick={reset}
                  className='btn btn-outline-secondary px-4'>
                  Tozalash
                </motion.button>
              )}
            </div>
          </motion.div>
        ) : (
          <div>
            {" "}
            <h4 className='fw-bold text-center text-danger mb-4'>
              Iltimos avval sanani tanlang
            </h4>{" "}
          </div>
        )}
      </div>
    </div>
  );
};

export default FileUpload;
